import React from 'react';
import { assertNever } from '../../../utils/helpers';

import { museum } from '../../../data';
import { RIntroContentRemotePersonalTranscriptionDemo } from './r-intro-content-remote-personal-demo';
import { RIntroContentRemotePersonalTranscriptionBrighton } from './r-intro-content-remote-personal-brighton';
import { RIntroContentRemotePersonalTranscriptionMunch } from './r-intro-content-remote-personal-munch';
import { RIntroContentRemotePersonalTranscriptionCop26 } from './r-intro-content-remote-personal-cop26';


const Transcript = (museum.slug === 'demo') ? RIntroContentRemotePersonalTranscriptionDemo
                 : (museum.slug === 'brighton') ? RIntroContentRemotePersonalTranscriptionBrighton
                 : (museum.slug === 'munch') ? RIntroContentRemotePersonalTranscriptionMunch
                 : (museum.slug === 'mpu') ? RIntroContentRemotePersonalTranscriptionDemo
                 : (museum.slug === 'cop-26') ? RIntroContentRemotePersonalTranscriptionCop26
                 : assertNever(museum.slug);


const RIntroContentRemotePersonalTranscription: React.FC = () => {
  return <Transcript />;
};

export {
  RIntroContentRemotePersonalTranscription,
};
